if (!customElements.get('terence-hero-video')) {
  customElements.define('terence-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const sync = () => {
        button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
        button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
      };
      video.muted = true;
      button.hidden = false;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(sync);
        else video.pause();
      });
      this.motionChange = () => { if (motion.matches) video.pause(); };
      motion.addEventListener('change', this.motionChange);
      this.motion = motion;
      if (!motion.matches) video.play().catch(sync);
      sync();
    }
    disconnectedCallback() {
      this.motion?.removeEventListener('change', this.motionChange);
      this.querySelector('video')?.pause();
      this.ready = false;
    }
  });
}
